import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, Link2 } from "lucide-react";
import SparkLogo from "./SparkLogo";
import { CATEGORIES } from "../data/site";

export default function Footer() {
  return (
    <footer className="bg-ink pb-10 pt-16 text-white/70" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <SparkLogo light />
            <p className="mt-4 max-w-xs text-sm leading-relaxed">
              Where Kids Shine. Playful, pastel-perfect kidswear made for
              non-stop play and sparkling childhood moments.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[
                {
                  icon: Instagram,
                  label: "Instagram",
                  href: "https://www.instagram.com/sparkwear___",
                  external: true,
                  testid: "social-instagram",
                },
                {
                  icon: Facebook,
                  label: "Facebook",
                  href: "https://www.facebook.com/share/1CAVe9ZxE6/",
                  external: true,
                  testid: "social-facebook",
                },
                {
                  icon: Mail,
                  label: "Email",
                  href: "mailto:sparkspacefind@gmail.com",
                  external: false,
                  testid: "social-email",
                },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  aria-label={s.label}
                  data-testid={s.testid}
                  target={s.external ? "_blank" : undefined}
                  rel={s.external ? "noopener noreferrer" : undefined}
                  className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/15 transition-colors duration-200 hover:bg-white/10"
                >
                  <s.icon className="h-4 w-4" />
                </a>
              ))}
              <a
                href="/track"
                data-testid="footer-track-link"
                className="inline-flex items-center gap-2 rounded-full border border-white/15 px-5 py-2.5 text-sm font-semibold text-white/85 transition-colors duration-200 hover:bg-white/10 hover:text-white"
              >
                <Link2 className="h-4 w-4" />
                Track your order
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-white">
              Shop
            </h3>
            <ul className="mt-5 grid grid-cols-1 gap-3 text-sm">
              {CATEGORIES.map((c) => (
                <li key={c.id}>
                  <Link
                    to={`/shop?cat=${c.id}`}
                    data-testid={`footer-category-link-${c.id}`}
                    className="transition-colors duration-200 hover:text-white"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-white">
              Help & Info
            </h3>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <Link to="/shop#delivery" data-testid="footer-link-delivery-returns" className="transition-colors duration-200 hover:text-white">
                  Delivery Information
                </Link>
              </li>
              <li>
                <Link to="/shop#delivery" data-testid="footer-link-returns" className="transition-colors duration-200 hover:text-white">
                  Returns & Exchanges
                </Link>
              </li>
              <li>
                <Link to="/shop#size-guide" data-testid="footer-link-size-guide" className="transition-colors duration-200 hover:text-white">
                  Size Guide
                </Link>
              </li>
              <li>
                <Link to="/#reviews" data-testid="footer-link-reviews" className="transition-colors duration-200 hover:text-white">
                  Customer Reviews
                </Link>
              </li>
              <li>
                <Link to="/contact" data-testid="footer-link-contact" className="transition-colors duration-200 hover:text-white">
                  Contact us
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-7 text-xs sm:flex-row">
          <p>© {new Date().getFullYear()} Sparkwear — Where Kids Shine.</p>
          <p>Made with love for little humans.</p>
          <Link
            to="/admin"
            data-testid="footer-studio-link"
            className="rounded-full border border-white/15 px-4 py-1.5 font-semibold text-white/60 transition-colors duration-200 hover:bg-white/10 hover:text-white"
          >
            Studio
          </Link>
        </div>
      </div>
    </footer>
  );
}
